import React, { Fragment } from 'react';
import { getSkinFromStorageOrDefault } from '../../../shared';
import PropTypes from 'prop-types';
import { isEmbbededInTeams } from '../../../services/crossPlatform/crossPlatformService';
import { Translate } from 'react-redux-i18n-lite';

const NoHome = ({ username }) => {
  const theme = getSkinFromStorageOrDefault();
  const cssClassName = 'classroom-container-title';
  return (
    <Fragment>
      <div className="classrooms-container">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span className={cssClassName}>
            <span data-cy="welcomeMessage">
              <Translate value="home.welcome" />, {username}!
            </span>
          </span>
        </div>
      </div>
      <div className="empty-classroom-placeholder">
        <div className="content">
          <img src={theme.images.placeholders.emptyClassrooms} alt="emptyHome" />
          <div className="text-info">
            <Translate value="home.teacher.empty.info-createClassNotEnabled" />
          </div>
        </div>
      </div>
    </Fragment>
  );
};
NoHome.propTypes = {
  username: PropTypes.string.isRequired
};
export default NoHome;
